module.exports = __webpack_public_path__ + "static/classic-8c05738ddc7d6c50cc68515a34cbf3d0.jpg";